import { render, staticRenderFns } from "./PageDesignerChrome.vue?vue&type=template&id=5067709a&scoped=true&"
import script from "./PageDesignerChrome.vue?vue&type=script&lang=js&"
export * from "./PageDesignerChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067709a",
  null
  
)

export default component.exports